import React, { useEffect, useRef } from 'react';
import HTMLReactParser from 'html-react-parser';
import { useHistory } from 'react-router-dom';
import PATHS from 'constants/paths';

import { CONSENT_STATUS } from "constants/cookie-consent";
import { useTranslate } from 'context/LanguageContext';
import { useCookieConsent } from 'context/CookieConsentContext';
import Button from "components/buttons/Button";

import cookie_icon from "svg/cookies.svg";
import "./cookies-confirm.scss";

const CURRENT_CHOICE_LABELS = {
	[ CONSENT_STATUS.GRANTED ]: "cookie_confirm_current_granted",
	[ CONSENT_STATUS.DENIED ]: "cookie_confirm_current_denied"
}

export default function CookieConfirm() {

	const history = useHistory();
	const translate = useTranslate();
	const container_ref = useRef( null );
	const { status, is_settings_open, is_banner_visible, accept, reject } = useCookieConsent();

	// The banner reopened from the footer appears far from the clicked link, so focus has to follow it
	useEffect(() => {
		is_settings_open && container_ref.current && container_ref.current.focus();
	}, [ is_settings_open ]);


	const onContentClick = e => {
		if ( e.target.tagName !== "A" ) return;

		e.preventDefault();
		history.push( PATHS.PRIVACY_POLICY );
	}


	return is_banner_visible
		? (
			<div
				className="cookies-confirm"
				role="region"
				aria-label={ translate( "cookie_settings" )}
				tabIndex="-1"
				ref={ container_ref }
			>
				<div className="cookies-confirm__container">
					{ window.innerWidth >= 900 && <img src={ cookie_icon } alt="" /> }

					<div className="cookies-confirm__content" onClick={ onContentClick }>
						{ HTMLReactParser( translate( "cookie_confirm_text" ))}

						{ CURRENT_CHOICE_LABELS[ status ] && (
							<p className="cookies-confirm__current">
								{ translate( CURRENT_CHOICE_LABELS[ status ] )}
							</p>
						)}
					</div>

					<div className="cookies-confirm__buttons">
						<Button extra_classes="filled" onClick={ reject }>
							{ translate( "cookie_confirm_reject_btn" )}
						</Button>

						<Button extra_classes="filled" onClick={ accept }>
							{ translate( "cookie_confirm_btn" )}
						</Button>
					</div>
				</div>
			</div>
		)
		: null
}
